(function () {
  function initCarousel(root) {
    if (root.dataset.bmHpCarouselReady) return;
    root.dataset.bmHpCarouselReady = '1';

    var track = root.querySelector('[data-bm-hp-track]');
    if (!track) return;

    var prev = root.querySelector('[data-bm-hp-prev]');
    var next = root.querySelector('[data-bm-hp-next]');
    var amount = function () {
      return Math.max(track.clientWidth * 0.8, 240);
    };

    var update = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -amount(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: amount(), behavior: 'smooth' });
      });
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function placeHotspots(root) {
    var media = root.querySelector('.bm-hp-look__media');
    var img = media && media.querySelector('img');
    if (!media) return;
    var bw = media.clientWidth;
    var bh = media.clientHeight;
    if (!bw || !bh) return;

    var natW = (img && img.naturalWidth) || (img && parseInt(img.getAttribute('width'), 10)) || 2200;
    var natH = (img && img.naturalHeight) || (img && parseInt(img.getAttribute('height'), 10)) || 930;
    if (!natW || !natH) return;
    var ir = natW / natH;
    var br = bw / bh;
    var dispW;
    var dispH;
    var offX;
    var offY;
    if (br < ir) {
      dispH = bh;
      dispW = bh * ir;
      offX = (dispW - bw) / 2;
      offY = 0;
    } else {
      dispW = bw;
      dispH = bw / ir;
      offX = 0;
      offY = (dispH - bh) / 2;
    }

    media.querySelectorAll('[data-bm-hp-hotspot]').forEach(function (dot) {
      var hx = parseFloat(dot.getAttribute('data-hx'));
      var hy = parseFloat(dot.getAttribute('data-hy'));
      if (isNaN(hx) || isNaN(hy)) return;
      var x = (hx / 100) * dispW - offX;
      var y = (hy / 100) * dispH - offY;
      var visible = x >= 10 && x <= bw - 10 && y >= 10 && y <= bh - 10;
      dot.classList.toggle('is-out', !visible);
      dot.style.left = (x / bw) * 100 + '%';
      dot.style.top = (y / bh) * 100 + '%';
      dot.classList.toggle('bm-hp-hotspot--left', x / bw > 0.7);
      dot.classList.toggle('bm-hp-hotspot--bottom', y / bh < 0.28);
    });
    media.classList.add('is-framed');
  }

  function initHotspots(root) {
    if (!root || root.dataset.bmHpLookReady) return;
    root.dataset.bmHpLookReady = '1';

    var dots = root.querySelectorAll('[data-bm-hp-hotspot]');
    var media = root.querySelector('.bm-hp-look__media');
    var img = media && media.querySelector('img');
    var frame = function () {
      placeHotspots(root);
    };
    frame();
    if (img) img.addEventListener('load', frame);
    if (media && window.ResizeObserver) {
      var observer = new ResizeObserver(frame);
      observer.observe(media);
    } else {
      window.addEventListener('resize', frame);
    }
    if (!dots.length) return;

    dots.forEach(function (dot) {
      var btn = dot.querySelector('.bm-hp-hotspot__btn');
      if (!btn) return;
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var open = dot.classList.contains('is-open');
        dots.forEach(function (other) {
          other.classList.remove('is-open');
          var otherBtn = other.querySelector('.bm-hp-hotspot__btn');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          dot.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (root.contains(event.target)) return;
      dots.forEach(function (dot) {
        dot.classList.remove('is-open');
        var btn = dot.querySelector('.bm-hp-hotspot__btn');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-bm-hp-carousel]').forEach(initCarousel);
    (scope || document).querySelectorAll('[data-bm-hp-look]').forEach(initHotspots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
